import { Collapse, Tab, Tabs } from "@blueprintjs/core";
import omit from "lodash/omit";
import React from "react";

import { ID } from "common/entities/IEntity";
import Loading from "common/fragments/Loading";
import NonIdealState from "common/fragments/NonIdealState";
import AutoForm from "core/components/AutoForm";
import { EntityEditWrapper } from "core/components/EntityEditWrapper";
import { FragmentLayout } from "core/components/FragmentLayout";
import { IPanelProps, Panel } from "core/decorators/Panel";
import AppToaster from "core/util/AppToaster";
import TokenSession from "core/util/session/TokenSession";
import ArticleList from "./article/admin/ArticleList";
import CategoryList from "./category/admin/CategoryList";
import KnowledgeBasePanelConfig from "./config/KnowledgeBasePanelConfig";
import constants from "./constants";
import GlossaryTermList from "./glossary/GlossaryTermList";
import { KnowledgeBase } from "./knowledgeBase/entities";
import * as kbFragments from "./knowledgeBase/KnowledgeBaseFragments";

const KbEditWrapper = EntityEditWrapper.ofType<KnowledgeBase>();

interface IKnowledgeBasePanelState {
	selected: ID;
}

@Panel({
	id: "kb-knowledge-base",
	configClass: KnowledgeBasePanelConfig,
	pageParams: true
})
class KnowledgeBasePanel extends React.Component<
	IPanelProps<KnowledgeBasePanelConfig>,
	IKnowledgeBasePanelState
> {
	public state = { selected: null };

	public render() {
		const { config, pageParams } = this.props;

		const params = {};

		if (config.knowledgeBaseGuid) {
			params["guid"] = config.knowledgeBaseGuid;
		} else {
			return (
				<NonIdealState
					title="No Knowledge Base Selected"
					description=""
				/>
			);
		}

		return (
			<KbEditWrapper
				canEdit={TokenSession.hasRoles("ROLE_ADMIN")}
				entity={KnowledgeBase}
				params={params}
				onBeforeSave={this.onBeforeSave}
				onAfterSave={this.onAfterSave}
				title="Edit Knowledge Base"
			>
				{args => {
					if (args.loading) {
						return <Loading />;
					}

					if (!args.data) {
						return (
							<NonIdealState
								title="Invalid Knowledge Base"
								description=""
							/>
						);
					}

					return (
						<div>
							<Collapse isOpen={args.editing}>
								<div
									style={{
										padding: "15px",
										backgroundColor: "#f5f8fa"
									}}
								>
									<Tabs id="kb:edit">
										<Tab
											id="general"
											title="General"
											panel={
												<AutoForm
													clazz={KnowledgeBase}
													value={args.data}
													onChange={args.onChange}
												/>
											}
										/>
										<Tab
											id="categories"
											title="Categories"
											panel={
												<CategoryList
													knowledgeBaseId={
														args.data.id
													}
													topLevel={true}
												/>
											}
										/>
										<Tab
											id="articles"
											title="Articles"
											panel={
												<ArticleList
													knowledgeBaseId={
														args.data.id
													}
													includeDeleted={true}
												/>
											}
										/>
										<Tab
											id="glossary"
											title="Glossary"
											panel={
												<GlossaryTermList
													knowledgeBaseId={
														args.data.id
													}
												/>
											}
										/>
									</Tabs>
								</div>
							</Collapse>
							<FragmentLayout
								fragments={kbFragments}
								layout={config.layout}
								props={{
									knowledgeBase: args.data,
									config,
									currentCategory:
										pageParams[constants.PARAM_CATEGORY_ID]
								}}
							/>
						</div>
					);
				}}
			</KbEditWrapper>
		);
	}

	private onBeforeSave = (data: KnowledgeBase) => {
		return omit(data, ["categories"]);
	};

	private onAfterSave = () => {
		AppToaster.show({
			message: "Saved Successfully",
			intent: "success"
		});
	};
}



// WEBPACK FOOTER //
// ./src/panels/kb/KnowledgeBase.panel.tsx